export enum BlockType {
  PageHeading = 'page-heading',
  SubsectionHeading = 'subsection-heading',
  QuestionLabel = 'question-label',
  LongTextInput = 'long-text-input',
  Paragraph = 'paragraph',
  SingleSelectInput = 'single-select-input',
  SelectInputOption = 'select-input-option',
  FileInput = 'file-input',
  MultiSelectInput = 'multi-select-input',
  ShortTextInput = 'short-text-input',
  SectionHeading = 'section-heading',
}
